module.exports = __webpack_public_path__ + "img/bg_1_1.be95c53a.png";